import React, { useState } from "react";
import "./SingleProject.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeBranch, faEye } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
const SingleProject = (data) => {
  const { img, name, git, live, des, modal } = data.data;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View Project
    </Tooltip>
  );
  const renderToolGit = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View Source Code
    </Tooltip>
  );
  return (
    <div className="col-md-3 mb-4 offset-1">
      <div class="carb-list">
        <div class="image">
          <img src={img} alt="" />
        </div>
        <div class="details">
          <div class="center">
            <h1 style={{ color: "#ffa500" }}>{name}</h1>
            <p>{des}</p>
            <button className="project-btn" onClick={handleShow}>
              Show Details
            </button>

            <Modal className="special_modal" show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{modal}</Modal.Body>
            </Modal>
            <ul>
              <li>
                <div className="d-flex justify-content-center">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderToolGit}
                  >
                    <a target="blank" href={git}>
                      <FontAwesomeIcon
                        style={{
                          width: "20px",
                          height: "20px",
                          paddingBottom: "5px",
                        }}
                        className="service-icon"
                        icon={faCodeBranch}
                      />
                    </a>
                  </OverlayTrigger>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-center">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                  >
                    <a target="blank" href={live}>
                      <FontAwesomeIcon
                        style={{
                          width: "20px",
                          height: "20px",
                          paddingBottom: "5px",
                        }}
                        className="service-icon"
                        icon={faEye}
                      />
                    </a>
                  </OverlayTrigger>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleProject;
